import styled from "styled-components";
import { Flex, Box } from "@edricphan2022/uikit";
import mediaQueries from "../../@uikit/theme/base";

export const Wrapper = styled(Box)`
  width: 100%;
  position: relative;
  // background: linear-gradient(180deg, #fffef6 0%, rgba(251, 251, 243, 0) 100%);
`;

export const HowWorksStyle = styled(Box)`
  width: 100%;
  height: 100%;
  // background: #fefbef;
  padding-top: 90px;
  background-image: url("/assets/about/BannerAbout.svg");
  background-size: contain;
  background-position: center;
  position: relative;
  :after {
    content: "";
    width: 89.895833333%;
    height: 65%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333333;
    z-index: -1;
    border-radius: 16px;
  }
  @media only screen and (max-width: 767px) {
    :after {
      height: auto;
      aspect-ratio: 676/375;
    }
  }
`;

export const BoxTop = styled(Box)`
  width: 100%;
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  p {
    color: #333333;
    font-size: 20px;
    font-weight: 400;
    font-family: ManropeRegular;
    line-height: 30px;
    margin-top: 30px;
  }
  .BackGround-black {
    position: relative;
    aspect-ratio: 676/422;
    width: 89.895833333%;
    max-width: 676px;
  }
  .Box1 {
    position: absolute;
    left: 4.4%;
    top: 37.6%;
    animation: AnimationsBox 3s linear infinite;
    width: 9%;
  }
  .Box2 {
    position: absolute;
    left: 41.4%;
    top: 68.6%;
    animation: AnimationsBox 3s linear infinite;
    animation-delay: 1.5s;
    width: 9%;
  }
  .Box3 {
    position: absolute;
    left: 76.4%;
    top: 58.6%;
    animation: AnimationsBox 3s linear infinite;
    width: 9%;
  }
  .Box4 {
    position: absolute;
    left: 76.4%;
    top: 17.6%;
    animation: AnimationsBox 3s linear infinite;
    animation-delay: 1.5s;
    width: 9%;
  }
  @keyframes AnimationsBox{
    0%{
      transform: translateY(0%);
    }
    50%{
      transform: translateY(50%);
    }
    100%{
      transform: translateY(0%);
    }
  }
`;

export const BoxRoadMap = styled(Box)`
  width: 100%;
  height: 100%;
  padding-top: 88px;
  padding-bottom: 90px;
  position: relative;
  h1{
    color: #303031;
    font-size: 40px;
    font-weight: 700;
    line-height: 41px;
    font-family: ManropeBold;
    margin-bottom: 36px;
  }
  h2{
    color: #303031;
    font-size: 20px;
    font-weight: 400;
    line-height: 22.5px;
    font-family: ManropeRegular;
    margin-bottom: 58px;
  }
  h3{
    margin: 0px;
    color: #303031;
    font-size: 40px;
    font-weight: 700;
    line-height: 64px;
    font-family: ManropeBold;
    margin-bottom: 35px;
  }
  p{
    width: 100%;
    max-width: 485px;
    margin: 0px;
    color: #303031;
    font-size: 20px;
    font-weight: 400;
    line-height: 22.5px;
    font-family: ManropeRegular;
  }
  .BoxContent1{
    max-height: 180px;
    margin-top: 40px;
    margin-bottom: 70px;
    p{
      padding-left: 27px;
      position: relative;
      color: #333333;
      font-size: 16px;
      line-height: 18px;
      font-family: ManropeBold;
      font-weight: 700;
      margin-bottom: 18px;
      :before{
        content: "";
        width: 18px;
        height: 2px;
        position: absolute;
        left: 0;
        top: 8px;
        background-color: #F2E14C;
      }
    }
    div{
      height: 100%;
    }
  }
  .BoxContent2{
    align-items: flex-start;
    h4 , p{
      color: #333333;
    }
    h4{
      font-size: 20px;
      font-family: "ManropeBold";
      line-height: 23px;
      margin-bottom: 20px;
    }
    p{
      font-size: 16px;
      font-family: "ManropeRegular";
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 40px;
    }
    .BoxGroup{
      height: 100%;
      max-width: 31%;
    }
  }
  @media only screen and (max-width: 1140px){
    .BoxContent1{
      max-height: 10000px;
      div{
        width: 100%;
      }
    }
    .BoxContent2{
      .BoxGroup{
        width: 100%;
        max-width: 100%;
        p{
          max-width: 100%;
        }
      }
    }
  }
  @media only screen and (max-width: 768px){
    padding-top: 24px;
    h1{
      font-size: 24px;
      line-height: 24px;
    }
    h2{
      font-size: 16px;
      line-height: 18px;
    }
    h3{
      font-size: 24px;
      line-height: 30px;
    }
  }
`;
export const BoxContent = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 30%;
  }
  @media only screen and (max-width: 1140px){
    flex-direction: column;
    img{
      position: relative;
      transform: none;
      top: 0;
      left: 0;
      width: 100%;
      max-width: 560px;
    }
  }
`

export const BoxBlockchainTech = styled(Flex)`
  flex-wrap: wrap;
  & > * {
    width: calc(6 / 12 * 100%);
    padding: 8px;
  }

  .box-children {
    padding: 20px 17px;
    /* border: 1px solid #e7e7e8;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) -30.29%, rgba(255, 255, 255, 0) 144.92%);
    backdrop-filter: blur(50px); */
    border-radius: 15px;
    margin-bottom: 96px;

    .item-icon {
      position: relative;
      margin-bottom: 36px;
      /* ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(255, 237, 155, 0.5) 12.79%, rgba(247, 218, 87, 0) 69.15%);
        border-radius: 30px 0px 0px 30px;
        z-index: -1;
      } */
    }
  }

  ${mediaQueries.mediaQueries.sm} {
    & > * {
      width: 100%;
    }
  }
`;

export const WeUs = styled(Box)`
  width: 100%;
  height: 100%;
  background: #fffdf9;
  padding-top: 48px;
  padding-bottom: 48px;
  background-image: url("/assets/home/backgroundV1.svg");
  background-position: center;
  position: relative;
`;

export const BoxInTouch = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 84px;
  padding-bottom: 30px;

  .cus-intouch-orbit {
    align-items: flex-start !important;

    & > * {
      width: 50%;
      position: relative;
    }
    & > *:nth-child(2) {
      min-height: 480px;
    }
  }

  ${mediaQueries.mediaQueries.sm} {
    padding-bottom: 100px;
    .cus-intouch-orbit {
      flex-direction: column;

      & > * {
        width: 100%;
      }

      & > *:nth-child(2) {
        min-height: 420px;
      }
    }
  }
`;

export const TecWeUses = styled(Flex)`
  & > *:nth-child(1) {
    width: 40%;
    text-align: center;
  }

  .cus-line {
    position: relative;
    display: inline-block;
    width: 18px;
    height: 2px;
    background: #f2e14c;
    margin-right: 14px;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;

    & > *:nth-child(1) {
      display: flex;
      width: 100%;
      overflow: auto;
      gap: 10px;

      ::-webkit-scrollbar-thumb {
        display: none;
      }

      & > * {
        width: 100%;
      }
    }
  }
`;

export const ButtonTabs = styled.button`
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  padding: 15px 6px;
  font-size: 20px;
  letter-spacing: 6px;
  color: #1e1e23;
  cursor: pointer;
  border-radius: 8px;
  transition: 0.3s ease;

  :disabled {
    border: 1px solid #f7da57;
    background: #f7da57;
  }

  :hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
`;
